import React, { createContext, useCallback, useContext, useMemo, useRef } from "react";
import { resolvePublicListingContract } from "../../utils/publicListingContracts";

const PublicListingImageBudgetContext = createContext(null);

export function PublicListingImageBudgetProvider({ family = "", routeKey = "", children }) {
  const contract = useMemo(() => resolvePublicListingContract(family), [family]);
  const nextIndexRef = useRef(0);
  const generationRef = useRef(routeKey);
  if (generationRef.current !== routeKey) {
    generationRef.current = routeKey;
    nextIndexRef.current = 0;
  }

  const reserve = useCallback(() => {
    const index = nextIndexRef.current;
    nextIndexRef.current += 1;
    return Object.freeze({
      family,
      index,
      priority: Boolean(family && index < contract.eagerImages),
      loading: family && index < contract.eagerImages ? "eager" : "lazy",
      maxItems: contract.maxItems,
    });
  }, [contract.eagerImages, contract.maxItems, family]);

  const value = useMemo(() => ({ family, reserve }), [family, reserve]);
  if (!family) return children;
  return (
    <PublicListingImageBudgetContext.Provider value={value}>
      {children}
    </PublicListingImageBudgetContext.Provider>
  );
}

export const usePublicListingImageBudget = () => useContext(PublicListingImageBudgetContext);

export default PublicListingImageBudgetProvider;
